import { createConsumer, type Consumer } from "@rails/actioncable";

let consumer: Consumer | null = null;

interface Handlers {
  onChange: () => void;
  // Changes broadcast while the socket was down are lost, so a reconnect must refetch.
  onReconnect: () => void;
}

export function subscribeToChanges({ onChange, onReconnect }: Handlers): () => void {
  consumer ??= createConsumer();
  let connectedBefore = false;
  const subscription = consumer.subscriptions.create("SyncChannel", {
    connected() {
      if (connectedBefore) onReconnect();
      connectedBefore = true;
    },
    received: onChange,
  });
  return () => subscription.unsubscribe();
}

// The socket stays authenticated as whoever opened it, so a sign-out must drop it.
export function disconnectLiveSync(): void {
  consumer?.disconnect();
  consumer = null;
}
